import React, { useEffect, useMemo, useState } from 'react';

import { ScrollTopContext, IScrollTopContext } from './use-scroll-position';

export * from './use-scroll-position';

interface IProps {
  children: React.ReactElement | React.ReactElement[];
  onScroll?: (pos: IScrollTopContext) => void;
}

/**
 * @warning Children should either be a ReactElement or an array of ReactElement, but not components.
 */
function ScrollPosition(props: IProps) {
  const { children, onScroll } = props;
  // const ref = useRef<HTMLElement>();
  const [scrollPos, setScrollPos] = useState<IScrollTopContext>({
    scrollTop: 0,
    scrollLeft: 0,
  });

  useEffect(() => {
    // const elem = ref.current || document;
    // const target = ref.current || document.documentElement;
    const elem = document;
    const handler = () => {
      setScrollPos({
        scrollTop: document.documentElement?.scrollTop || document.body?.scrollTop || 0,
        scrollLeft: document.documentElement?.scrollLeft || document.body?.scrollLeft || 0,
      });
    };

    elem?.addEventListener('scroll', handler);

    return () => {
      elem?.removeEventListener('scroll', handler);
    };
  }, []);

  useEffect(() => {
    onScroll?.(scrollPos);
  }, [scrollPos, onScroll]);

  const ctxVal = useMemo(() => {
    return scrollPos;
  }, [scrollPos]);

  return (
    <ScrollTopContext.Provider value={ctxVal}>
      {React.Children.map(children, (element: any) => {
        return React.cloneElement(element, {
          // ref: (r: HTMLElement) => {
          //   ref.current = r;
          // },
        });
      })}
    </ScrollTopContext.Provider>
  );
}

export default ScrollPosition;
